import React from 'react';

function AddItemModal({
  showAddModal,
  setShowAddModal,
  handleAddItem,
  itemSearch,
  setItemSearch,
  searchResults,
  setSearchResults,
  selectedItem,
  setSelectedItem,
  targetStock,
  setTargetStock,
  addingItem,
  error,
  setError
}) {
  const closeModal = () => {
    setShowAddModal(false);
    setItemSearch('');
    setSearchResults([]);
    setSelectedItem(null);
    setTargetStock(0);
    setError('');
  };

  if (!showAddModal) return null;

  return (
    <div className="modal-overlay">
      <div className="modal add-item-modal">
        <div className="modal-header">
          <h3>Add Item to Seed</h3>
          <button
            onClick={closeModal}
            className="icon-btn modal-close"
          >
            ×
          </button>
        </div>
        <form onSubmit={handleAddItem}>
          <div className="form-group">
            <label htmlFor="itemSearch">Search for Item:</label>
            <input
              id="itemSearch"
              type="text"
              value={itemSearch}
              onChange={(e) => setItemSearch(e.target.value)}
              placeholder="Start typing item name..."
              disabled={addingItem}
              autoFocus
            />
            {searchResults.length > 0 && (
              <div className="search-results">
                {searchResults.map((item) => (
                  <div
                    key={item.type_id}
                    className={`search-result-item ${selectedItem?.type_id === item.type_id ? 'selected' : ''}`}
                    onClick={() => {
                      setSelectedItem(item);
                      setItemSearch(item.type_name);
                      setSearchResults([]);
                    }}
                  >
                    {item.type_name}
                  </div>
                ))}
              </div>
            )}
          </div>

          {selectedItem && (
            <div className="form-group">
              <label htmlFor="targetStock">Target Stock:</label>
              <input
                id="targetStock"
                type="number"
                min="0"
                value={targetStock}
                onChange={(e) => setTargetStock(parseInt(e.target.value) || 0)}
                disabled={addingItem}
              />
            </div>
          )}

          {error && <div className="error-message">{error}</div>}

          <div className="modal-actions">
            <button
              type="button"
              onClick={closeModal}
              disabled={addingItem}
              className="btn btn-ghost"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={addingItem || !selectedItem}
              className="btn btn-primary"
            >
              {addingItem ? 'Adding...' : 'Add Item'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AddItemModal;